import { render, staticRenderFns } from "./ActivixBanner.vue?vue&type=template&id=28a8a245&"
import script from "./ActivixBanner.vue?vue&type=script&lang=js&"
export * from "./ActivixBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports